import Cookies from 'js-cookie'
import { KEY_TOKEN } from '../configs/system'
import {getPassioDomain} from "@features/share/utils/subDomain";
const PASSIO_MAIN_DOMAIN = getPassioDomain()


export function isClient() {
  return typeof  window !== "undefined"
}

export function isLocal() {
  return process.env.NEXT_PUBLIC_ENVIRONMENT === 'local'
}

export function isDevelopment() {
  return process.env.NEXT_PUBLIC_ENVIRONMENT === 'dev'
}

export function isStaging() {
  return process.env.NEXT_PUBLIC_ENVIRONMENT === 'staging'
}

export function isProduction() {
  return process.env.NEXT_PUBLIC_ENVIRONMENT === 'prod'
}

export function logError(e, path = null) {
  console.log(e, '//'+path)
}

export function hasCookie() {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const token = Cookies.get(KEY_TOKEN, {domain: PASSIO_MAIN_DOMAIN, path: '/'})
  return token 
}
